export default __webpack_public_path__ + "media/images/react_icons/laundry-19fc0ac37e91aa0c6bcf096b3fe98c8c.svg";